import baseTheme from "./SignatureCard.theme.base";
import { createTheme } from "../../../../../../functions/createTheme";
import { SignatureCardTheme } from "../SignatureCard.types";
import { space } from "../../../../../../theming/bca/bca-attributes";

const bcaTheme: SignatureCardTheme = {
	base: {
		padding: space.xl,
	},

	breakpoint: {},
};

export default createTheme(bcaTheme, baseTheme);
